import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles.less';

export const Spinner = ( props ) => {

    // Construct the classes to use for the root component.
    const classes = classnames(
        'loading-spinner',
        { [ props.className ]: Boolean( props.className ) },
    );

    const spinnerTicks = useMemo( () => {
        const ticks = [];
        for ( let i = 0; i < props.tickCount; i++ ) {
            ticks.push( <div key={ `loading-spinner-tick-${ i }` } /> );
        }
        return ticks;
    }, [ props.tickCount ] );

    return (
        <div className={ classes }>
            { spinnerTicks }
        </div>
    );
};

Spinner.defaultProps = {
    className: undefined,
    tickCount: 12,
};

Spinner.propTypes = {
    className: PropTypes.string,
    tickCount: PropTypes.number,
};
